
export default "/assets/file-code.48b2a861.svg"